module.exports = "<div class=\"table-header-action flex-item\">\n\t<h3 class=\"heading-3 m-0\">Configured Integrations</h3>\n    <button [disabled]=\"!showCitcoButtons\" (click)=\"openAddIntegrationDialog()\" md-raised-button class=\"btn-secondary\">\n        <i class=\"material-icons\">add</i> New Integration</button>\n</div>\n\n<app-integration-list #integrations>Loading...</app-integration-list>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/integrations/integrations.component.html
// module id = 2145
// module chunks = 0